module.exports = __webpack_public_path__ + "img/buliding.da7fad9c.svg";